var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImage = function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#image_svg__a)",
    stroke: "currentColor",
    strokeWidth: 1.714
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.645 17.603c.264 2.47 2.25 4.456 4.719 4.731 1.834.205 3.716.38 5.635.38 1.92 0 3.802-.175 5.636-.38 2.468-.275 4.455-2.261 4.719-4.73.195-1.824.36-3.696.36-5.604s-.165-3.78-.36-5.603c-.264-2.47-2.25-4.456-4.72-4.731-1.833-.205-3.715-.38-5.635-.38-1.919 0-3.801.175-5.635.38-2.468.275-4.455 2.261-4.72 4.73C1.45 8.22 1.286 10.093 1.286 12s.165 3.78.36 5.603Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 11.143a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM6.365 22.334c-2.469-.275-4.455-2.261-4.72-4.73-.16-1.499-.3-3.03-.344-4.587a13.507 13.507 0 0 1 2.11-.16 12.617 12.617 0 0 1 12.55 9.65c-1.3.122-2.621.207-3.96.207-1.92 0-3.803-.175-5.636-.38Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.96 22.508c.562-.053 1.12-.112 1.674-.174 2.468-.275 4.455-2.261 4.719-4.73.03-.275.058-.55.085-.827a13.372 13.372 0 0 0-3.6-.491c-1.844-.004-3.67.37-5.365 1.097v.114a12.618 12.618 0 0 1 2.486 5.01Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "image_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgImage;